import React from 'react'
import PropTypes from 'prop-types'
import { NamePerson } from '../styles'

export function Name({name}) {
  return (
    <NamePerson>
      {name}
    </NamePerson>
  )
}

Name.propTypes = {
  name: PropTypes.string.isRequired,
}



